import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation  } from 'react-router-dom';
import AppRouter from "./components/AppRouter";
import './css/App.css';
import { observer } from "mobx-react-lite";
import { Context } from "./index";
import Header from "./components/Header";
import BarLine from "./components/BarLine";
import BrandsBlock from "./components/BrandsBlock";
import { hasRole } from "./http/userAPI";
import Footer from "./components/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = observer(() => {
    const {user} = useContext(Context);
    const location = useLocation();

    const barLineRef = useRef(null);
    const [barLineHeight, setBarLineHeight] = useState(0);

    // Список страниц, где не нужен хедер и футер
    const hideLayout = location.pathname === "/login";


/*    useEffect(() => {
        if (user.token) {
        //    console.log("Пользователь авторизован:", user);
        }

    }, [user]);*/
    
    useEffect(() => {        
        // Убеждаемся, что DOM уже полностью загрузился
        const updateHeight = () => {
            if (barLineRef.current) {
                const height = barLineRef.current.offsetHeight;
                setBarLineHeight(height);
            }
        };

        updateHeight(); // Вызываем сразу
        window.addEventListener("resize", updateHeight); // Пересчёт при изменении размера окна

        return () => window.removeEventListener("resize", updateHeight);
    }, []);
    
    // подтягиваем роли юзера
    const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkRoles = async () => {
      // если нет авторизации не запрашивать роли и присваивать ROLE_USER_FOR_SITE
      if (user.isAuth !== true || !user.token) {
        user.setHasRoleUserForSite(true);
        setLoading(false);
        return;
      }
      try {       
        const [shop, opt] = await Promise.all([
          hasRole("ROLE_SHOP"),
          hasRole("ROLE_OPT"),
        ]);
        user.setHasRoleShop(shop);
        user.setHasRoleOpt(opt);    
      } catch (e) {

        console.error("Ошибка при проверке ролей", e);

      localStorage.removeItem("token");
      localStorage.removeItem("user");
      user.setToken(null);
      user.setIsAuth(false);
      user.setHasRoleUserForSite(true);
      user.setviewAsManager(false);

      } finally {
        setLoading(false);
      }
    };

    checkRoles();
  }, [user]);


  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: '20%' }}>Загрузка...</div>;
  }
  
    return (
        <>
        {!hideLayout && <Header />} {/* Если не login, показываем хедер */}
        
        <BarLine ref={barLineRef}/> 
        <AppRouter barLineHeight={barLineHeight} />
        {!hideLayout && <BrandsBlock />} {/* Если не login, показываем BrandsBlock */}
       
        {!hideLayout && <Footer />} {/* Если не login, показываем футер */}
        <ToastContainer 
          position="top-center"
          autoClose={2000} // скрывается через 2 секунды
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark" // или "light" / "dark"  / colored
          className="toast-container-custom"
        />
         </>
       
    );
});

export default App;
/*      <BrowserRouter>
            <Header />
            <BarLine />
            {/*{user.token && <NavBar/>}*}
            <AppRouter/>
            {/*{user.token && <Footer/>}*}
            <BrandsBlock />
            <Footer />
        </BrowserRouter>
*/

